import { render } from "./add_role.vue?vue&type=template&id=360b0f3f"
import script from "./add_role.vue?vue&type=script&lang=js"
export * from "./add_role.vue?vue&type=script&lang=js"

import exportComponent from "/opt/nexus/frontend/v1/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__